import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=8fe8d22a&"
import script from "./Stat.vue?vue&type=script&lang=ts&"
export * from "./Stat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports